import { useEffect } from 'react'
import { Box, Button, Grid } from '@mui/material'
import { personalizationInitialState } from '@/state/personalization-engine'

import { CasinoComponent } from './casino'
import { FiltersComponent } from './filters'
import {
  usePersonalizationEngine,
  usePersonalizationEngineActions,
} from '../hooks'

type Props = {
  hideSearchByPlayer?: boolean
  playerId?: string
}

export const PersonalizationEngineComponent = ({
  hideSearchByPlayer,
  playerId,
}: Props) => {
  const { currentTab, setCurrentTab, buttonsArray, filters } =
    usePersonalizationEngine()

  const { setPersonalizationEngineFilters, resetPersonalizationData } =
    usePersonalizationEngineActions()

  useEffect(() => {
    if (playerId) {
      setPersonalizationEngineFilters({ ...filters, playerId })
    }
    return () => {
      setPersonalizationEngineFilters(personalizationInitialState.filters)
      resetPersonalizationData()
    }
  }, [playerId]) // eslint-disable-line

  return (
    <Box>
      <Grid container>
        <Grid item xs={4}>
          {buttonsArray.map((button) => (
            <Button
              key={button.id}
              variant={currentTab === button.label ? 'contained' : 'text'}
              size="small"
              onClick={() => setCurrentTab(button.label)}
              sx={{
                marginBottom: '24px',
              }}
            >
              {button.title}
            </Button>
          ))}
        </Grid>
        <Grid item xs={8}>
          <FiltersComponent hideSearchByPlayer={hideSearchByPlayer} />
        </Grid>
      </Grid>
      {currentTab === 'casino' && <CasinoComponent />}
    </Box>
  )
}
